import {
  LanguageModelV2CallWarning,
  LanguageModelV2FunctionTool,
  LanguageModelV2ProviderDefinedTool,
  LanguageModelV2ToolChoice,
} from '@ai-sdk/provider';

type ToolsInput = {
  tools?: Array<LanguageModelV2FunctionTool | LanguageModelV2ProviderDefinedTool>;
  toolChoice?: LanguageModelV2ToolChoice;
};

export function prepareTools(mode: ToolsInput): {
  tools?: Array<{
    functionDeclarations: Array<{
      name: string;
      description?: string;
      parameters?: any;
    }>;
  }>;
  toolConfig?: {
    functionCallingConfig: {
      mode: 'AUTO' | 'ANY' | 'NONE';
      allowedFunctionNames?: string[];
    };
  };
  toolWarnings: LanguageModelV2CallWarning[];
} {
  const toolWarnings: LanguageModelV2CallWarning[] = [];

  if (!mode.tools || mode.tools.length === 0) {
    return { toolWarnings };
  }

  const functionDeclarations = mode.tools
    .map(tool => {
      if (tool.type === 'provider-defined') {
        // Provider-defined tools are not supported by Cloud Code functionDeclarations.
        toolWarnings.push({
          type: 'unsupported-tool',
          tool,
          details: 'Provider-defined tools are not supported by this provider.',
        });
        return undefined;
      }

      // tool.type === 'function'
      // Remove $schema field if it exists (Cloud Code API doesn't accept it)
      let params: any = tool.inputSchema as any;
      if (params && typeof params === 'object' && '$schema' in params) {
        const { $schema, ...cleanParams } = params as Record<string, unknown> & {
          $schema?: unknown;
        };
        params = cleanParams;
      }

      return {
        name: tool.name,
        description: tool.description,
        parameters: params,
      };
    })
    .filter((decl): decl is NonNullable<typeof decl> => decl != null);

  const tools = [{
    functionDeclarations,
  }];

  // Map tool choice to Cloud Code format
  let toolConfig: any;
  
  if (mode.toolChoice) {
    if (mode.toolChoice.type === 'none') {
      toolConfig = {
        functionCallingConfig: {
          mode: 'NONE',
        },
      };
    } else if (mode.toolChoice.type === 'required') {
      toolConfig = {
        functionCallingConfig: {
          mode: 'ANY',
        },
      };
    } else if (mode.toolChoice.type === 'tool') {
      toolConfig = {
        functionCallingConfig: {
          mode: 'ANY',
          allowedFunctionNames: [mode.toolChoice.toolName],
        },
      };
    } else {
      // auto
      toolConfig = {
        functionCallingConfig: {
          mode: 'AUTO',
        },
      };
    }
  } else {
    // Default to AUTO
    toolConfig = {
      functionCallingConfig: {
        mode: 'AUTO',
      },
    };
  }

  return {
    tools,
    toolConfig,
    toolWarnings,
  };
}